// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"71ab2836","496":"9405a9b4","799":"36554afb"}[chunkId] + ".chunk.js";
};